define.alias("shared/components/shared/wizard/finish-button", "media/components/shared/wizard/finish-button");